import {
    Component, OnInit, ViewChild, ElementRef,
    Input, Output, EventEmitter
} from '@angular/core';
import { GatewayService } from '../../gateway.service';
import { Router, ActivatedRoute } from '@angular/router';
import { VcaAlertsService } from './../../../../../../../common/vca-alerts';
import { NgForm } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import { Subscription } from 'rxjs/Rx';
import { Response } from '@angular/http';
import { TranslateService, TranslatePipe, LangChangeEvent } from '@ngx-translate/core';
import { GlobalVariables } from '../../../../../../../common/global-variables';
import { AuthService } from '../../../../../../auth/auth.service';

const _ = require('lodash');
var $ = require('jquery');

@Component({
    selector: 'import-gateway-dialog',
    template: require('./import-gateway-dialog.html'),
    styles: [require('./import-gateway-dialog.scss')],
    providers: [
        TranslateService
    ]
})

export class ImportGatewayDialog {

    private dataModel = {
        vCenterInstanceUuid: '',
        edgeId: '',
    };
    private isSystemAdmin:boolean = false;
    private vcList = [];
    private nsxEdgeList = [];
    private isLoading: boolean = false;
    private showModal: boolean = false;
    private selectedVc: string = '';
    private selectedGateway: string = '';
    constructor(private gatewayService: GatewayService,
            private router: Router,
            private alert: VcaAlertsService,
            private activatedRoute: ActivatedRoute,
            private translate: TranslateService,
            public authService: AuthService) {
        translate.use(GlobalVariables.LOCALE);

        let roles = (this.authService.loggedInUserInfo && this.authService.loggedInUserInfo.roles) ? this.authService.loggedInUserInfo.roles : [];

        if (_.includes(roles, 'System Administrator')) {
            this.isSystemAdmin = true;
        }

    }

    ngOnChanges() {
    }

    resetData() {
        this.dataModel = {
            vCenterInstanceUuid: '',
            edgeId: ''
        };
        this.vcList = [];
        this.nsxEdgeList = [];
    }

    ngOnInit() {
        this.resetData();
        this.getAllVCs();
        this.showModal = true;
    }

    cancel() {
        this.router.navigate(['services/networking/gateways']);
    }

    onDialogClose(event) {
        if (!event) {
            this.cancel();
        }
    }

    logError(error, origin: String = '') {
        console.error('Error: ', error, (origin !== '') ? ' Error from ' + origin : '');
    }

    logOperationCompleted(msg: string) {
        console.log('Operation Completed: ', msg);
    }

    isFormValid() {
        if (this.dataModel.vCenterInstanceUuid && this.dataModel.edgeId) {
            return true;
        }
        return false;
    }

    getAllVCs() {
        this.vcList = [];
        this.isLoading = true;
        this.gatewayService.getVcList()
            .subscribe(
            (data: any) => {
                this.vcList = data;
            },
            error => {
                console.log('Failed to retrieve vCenters');
                this.isLoading = false;
            }
        );
    }

    getNsxEdges(vCenterInstanceUuid: string) {
        this.nsxEdgeList = [];
        this.isLoading = true;
        this.gatewayService.getNsxEdges(vCenterInstanceUuid)
            .subscribe(
            (data: any) => {
                this.nsxEdgeList = (typeof data.items !== 'undefined' && data.items.length > 0) ? data.items: [];
                if (this.nsxEdgeList.length === 0) {
                    this.nsxEdgeList = [{'edgeId': '0', 'name': 'No gateways available to import'}];
                } else {
                    this.nsxEdgeList.unshift({'edgeId': '0', 'name': 'Select'})
                }
            },
            error => {
                console.log('Failed to retrieve NSX Edges');
                this.isLoading = false;
            }
            );
    }

    importGateway() {
        this.isLoading = true;
        this.gatewayService.importGateway(this.dataModel)
            .subscribe(
            data => {
                this.isLoading = false;
                this.router.navigate(['services/networking/gateways']);
            },
            error => {
                console.log('Failed to import gateway');
                this.isLoading = false;
                this.router.navigate(['services/networking/gateways']);
            }
            );
    }

    onVcSelect(event) {
        this.dataModel.vCenterInstanceUuid = event;
        this.getNsxEdges(event);
    }
    onGWSelect(event) {
        this.dataModel.edgeId = (event !== '0') ? event : '';
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/networking/networking-vc/gateways/dialogs/import-gateway/import-gateway-dialog.component.ts